import LPreview from './src/main'

/* istanbul ignore next */
LPreview.install = function(Vue) {
  Vue.component(LPreview.name, LPreview)
}

export default LPreview
